// extracted by mini-css-extract-plugin
export default {"load":"Waiting_load__S+F3P","spinner":"Waiting_spinner__iANdI","spin":"Waiting_spin__xqvh7","loadStacked":"Waiting_loadStacked__SXAzz"};